module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../../biz-b2c-web-h5/config/loader/lodash-cherry-pick-loader.js!../../../../../../biz-b2c-web-h5/config/loader/yofo-cherry-pick-loader.js??ref--1-0!./addShowCase.tsx"));
	}, "ShowCaseAddView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShowCaseAddView!../biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/showCase/addShowCase.tsx
// module id = 1087
// module chunks = 438